import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';

import PreviewSoleProprietorshipForm1099MISCand1099NEC from './SoleProprietorshipForm1099MISCand1099NEC/preview';
import PreviewSaleofOtherAssets from './SaleofOtherAssets/preview';

export interface IPreviewSoleProprietorshipProps {}

export default function PreviewSoleProprietorship(
  props: IPreviewSoleProprietorshipProps,
) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Income">
        {routes.soleProprietorship.soleProprietorshipForm1099MISCand1099NEC && (
          <PreviewSoleProprietorshipForm1099MISCand1099NEC />
        )}
        {routes.soleProprietorship.saleofOtherAssets && (
          <PreviewSaleofOtherAssets />
        )}
      </PreviewExpandable>
    </>
  );
}
